// Vendor JS
import axios from "axios";
import Debug from 'debug';

// Custom JS
import httpBuildQuery from '../../util/http-build-query';

/* eslint-disable no-unused-expressions */

/**
 * This class handles (un)subscribing to post comments
 */
class CommentReplyNotification {
	init = () => {
		try {
			Debug(`cig:info:sage:class:CommentReplyNotification`)(`init start`);

			// Add click listener to subscribe button if a subscribe button exists in the markup
			this.addSubscribeToggleHandler();
		} catch (err) {
			Debug(`cig:error:sage:class:CommentReplyNotification`)(`init Error: %s %o`, err.message, err);
			throw new Error(err);
		}
	};

	getPostId = element => {
		// Get the post ID from the data attribute
		const postId = element.getAttribute(`data-post-id`);

		// No post ID data attribute, end execution
		if (!postId) {
			Debug(`cig:error:sage:class:CommentReplyNotification`)(`getPostId Error: Missing post ID data attribute or no attribute value`);
			throw new Error(`Missing post ID data attribute or no attribute value.`);
		}

		return postId;
	};

	/**
	 * Handler for the comment Subscribe/Unsubscribe button
	 *
	 * @param event
	 */
	subscribeToggleHandler = async event => {
		try {
			// Get the subscribe button element
			const subscribeButtonElement = event.target || event.srcElement;

			// Get the post's ID from a data attribute, if no data attribute or no value, this will throw an error
			const postId = this.getPostId(subscribeButtonElement);

			// Get button Label element
			const label = document.querySelector(`label[for="${subscribeButtonElement.id}"]`);

			// Show spinning animation
			label.innerHTML = `<i class="fa fa-refresh fa-spin"></i>`;

			// Update the post's meta key "comment_subscriptions" so it has or does not have the user's ID
			await axios.post(`/wp-ajax/?`,
				httpBuildQuery({
					action: `cig_comment_reply_subscribe`,
					post_id: postId,
				}));

			// Get the button container
			const subscribeButtonContainer = subscribeButtonElement.parentElement; // This also works -> document.querySelector('.comment-reply-notification.post');

			// If the user is subscribed to comments before the button was clicked update the UI to reflect unsubscribing them
			if (subscribeButtonElement.checked) {

				// Update button label to show the user is subscribed
				label.innerHTML = `<i class="fa fa-envelope" aria-hidden="true"></i>Unsubscribe`;

				if (subscribeButtonContainer !== undefined && subscribeButtonContainer !== null) {
					subscribeButtonContainer.classList.add(`subscribed`);
				}

			// The user was unsubscribed prior to clicking the button, update the button so they know they've subscribed
			} else {
				// Update button label to show the user is not subscribed
				label.innerHTML = `<i class="fa fa-envelope" aria-hidden="true"></i>Subscribe`;

				if (subscribeButtonContainer !== undefined && subscribeButtonContainer !== null) {
					subscribeButtonContainer.classList.remove(`subscribed`);
				}
			}

		} catch (err) {
			Debug(`cig:error:sage:class:CommentReplyNotification`)(`subscribeToggleHandler Error: %s %o`, err.message, err);
			throw new Error(err);
		}
	};

	/**
	 * If the comment subscribe button is on the page, then add the click listener
	 */
	addSubscribeToggleHandler = () => {
		try {
			const subscribeButtonElement = document.getElementById('comment_subscriptions_toggle');

			if (typeof subscribeButtonElement !== 'undefined' && subscribeButtonElement !== null) {
				subscribeButtonElement.addEventListener('click', this.subscribeToggleHandler);
			}

		} catch (err) {
			Debug(`cig:error:sage:class:CommentReplyNotification`)(`addSubscribeToggleHandler Error: %s %o`, err.message, err);
			throw new Error(err);
		}
	};

}

export default new CommentReplyNotification();
